import { gql } from '@apollo/client';

export const ORGANIZATION_FIELDS_FRAGMENT = gql`
    fragment OrganizationFields on Organization {
        OrganizationId
        PartnerList {
            OrganizationPartnerId
            Partner {
                Name
                OrganizationId
            }
            Organization {
                Name
                OrganizationId
            }
            OrganizationPartnerType {
                OrganizationPartnerTypeId
                Name
            }
        }
        OrganizationStateType {
            OrganizationStateTypeId
            Name
        }
        EmergencyPerson {
            UserId
            Firstname
            Lastname
            Fullname
            Phone
            Email
            OwnOrganization {
                OrganizationId
                Name
            }
        }
        Name
        Bin
        Created
        Updated
        WebPageUrl
        Logo
        UserCount
        MachineCount
        BusinessLine
        AdminUser {
            UserId
            Firstname
            Lastname
            Phone
            Email
        }
        Address {
            AddressId
            StreetAddr
            PostalCode
            City
            Country
            Lat
            Long
        }
        Plan {
            PlanId
            Name
        }
        Access {
            Read
            Create
            Delete
            Update
        }
        SubscriptionSummary {
            SubscriptionName
            Count
            MaxCount
        }
        Theme {
            ThemeId
            PrimaryColor
            PrimaryTextColor
            SecondaryColor
            SecondaryTextColor
            DashboardBgColor
            WarningColor
            SuccessColor
            DashboardImage
            DashboardBgImage
            OrganizationLogo
            LoginBackgroundImage
        }
    }
`;

export const PROJECT_ORGANIZATION_FIELDS_FRAGMENT = gql`
    fragment ProjectOrganizationFields on Organization {
        OrganizationId
        Name
        Bin
        Created
        Updated
        WebPageUrl
        Logo
        UserCount
        MachineCount
        BusinessLine
        AdminUser {
            UserId
            Firstname
            Lastname
            Phone
            Email
        }
        Address {
            AddressId
            StreetAddr
            PostalCode
            City
            Country
            Lat
            Long
        }
        Plan {
            PlanId
            Name
        }
        Access {
            Read
            Create
            Delete
            Update
        }
        SubscriptionSummary {
            SubscriptionName
            Count
            MaxCount
        }
        Theme {
            ThemeId
            PrimaryColor
            PrimaryTextColor
            SecondaryColor
            SecondaryTextColor
            DashboardBgColor
            WarningColor
            SuccessColor
            DashboardImage
            DashboardBgImage
            OrganizationLogo
            LoginBackgroundImage
        }
    }
`;

export const ORGANIZATION_PARTNER_FIELDS_FRAGMENT = gql`
    fragment OrganizationPartnerFields on OrganizationPartner {
        OrganizationPartnerId
        OrganizationPartnerType {
            OrganizationPartnerTypeId
            Name
        }
        Partner {
            OrganizationId
            Name
            Address {
                StreetAddr
                Lat
                Long
            }
        }
        Organization {
            OrganizationId
            Name
            Address {
                StreetAddr
                Lat
                Long
            }
        }
    }
`;

export const FR_ORGANIZATION_FIELDS = gql`
    fragment fr_OrganizationFields on Organization {
        OrganizationId
        Name
        Address {
            StreetAddr
            PostalCode
            City
            Country
        }
    }
`;
